import { getLastLocation } from '../../components/routing/LastLocationProvider'

export function hideLiveViewModal() {
	const previousLocation=getLastLocation()
	if(previousLocation){
		window.history.back(1)
	}else{
		window.location.hash=''
	}

}
